export function createAggregatedEventsQueryString(aggregatedEventId) {
    return `$filter=id in('${aggregatedEventId}')`;
}
export function createEventsQueryString(eventIds) {
    let splitIds = eventIds.split(";");
    let queryString = "$filter=id in(";
    let terminatingCharacter = ``;
    splitIds.forEach(function (eventId, index) {
        terminatingCharacter = splitIds.length - 1 > index ? `,` : `)`;
        queryString += `'${eventId}'${terminatingCharacter}`;
    });
    return queryString;
}
//# sourceMappingURL=QueryHelpers.js.map